import { transformGraphicNames } from './dataProcessor';

let tournamentDatesCache = null;
let tournamentDatesPromise = null;

/**
 * Fetch tournament dates from ATP Calendar API for both 2024 and 2025
 */
const fetchTournamentDates = async () => {
  // Return cached data immediately if available
  if (tournamentDatesCache) {
    console.log('📦 Using cached tournament dates');
    return tournamentDatesCache;
  }
  // If fetch is in progress, wait for it
  if (tournamentDatesPromise) {
    console.log('⏳ Waiting for tournament dates fetch in progress');
    return tournamentDatesPromise;
  }

  console.log('🌐 Fetching tournament dates from API...');
  tournamentDatesPromise = (async () => {
    try {
        // Fetch tournament dates from ATP API for both this year and last

        const currentYear = new Date().getFullYear();
        const previousYear = currentYear - 1;

        const [responsePrevious, responseCurrent] = await Promise.all([
            fetch(`https://atp-gfx-magma-api.azurewebsites.net/api/Calendar?year=${previousYear}`),
            fetch(`https://atp-gfx-magma-api.azurewebsites.net/api/Calendar?year=${currentYear}`)
        ]);
      
        const dataPreviousYear = await responsePrevious.json();
        const dataCurrentYear = await responseCurrent.json();
      
      const tournamentDates = {};
      
      // Helper function to map tournament names
      const mapTournamentName = (tournamentName, seoName) => {
      // Handle specific mappings based on tournament name and SEO
      if (tournamentName === 'ATP Masters 1000 Madrid' && seoName === '1000') {
        return 'Madrid';
      } else if (tournamentName === 'Rome' && seoName === '1000') {
        return 'Rome';
      } else if (tournamentName.includes('Miami') && seoName === '1000') {
        return 'Miami';
      } else if (tournamentName.includes('Indian Wells') && seoName === '1000') {
        return 'IndianWells';
      } else if (tournamentName.includes('Monte Carlo') && seoName === '1000') {
        return 'MonteCarlo';
      } else if (tournamentName.includes('Barcelona') && seoName === '500') {
        return 'Barcelona';
      } else if (tournamentName.includes('Dubai') && seoName === '500') {
        return 'Dubai';
      } else if (tournamentName.includes('Rotterdam') && seoName === '500') {
        return 'Rotterdam';
      } else if (tournamentName.includes('Hamburg') && seoName === '500') {
        return 'Hamburg';
      } else if (tournamentName.includes('Halle') && seoName === '500') {
        return 'Halle';
      } else if (tournamentName.includes('Queens') && seoName === '500') {
        return 'Queens';
      } else if (tournamentName.includes('Eastbourne') && seoName === '250') {
        return 'Eastbourne';
      } else if (tournamentName.includes('Bastad') && seoName === '250') {
        return 'Bastad';
      } else if (tournamentName.includes('Gstaad') && seoName === '250') {
        return 'Gstaad';
      } else if (tournamentName.includes('Los Cabos') && seoName === '250') {
        return 'LosCabos';
      } else if (tournamentName.includes('Washington') && seoName === '500') {
        return 'Washington';
      } else if (tournamentName.includes('Umag') && seoName === '250') {
        return 'Umag';
      } else if (tournamentName.includes('Kitzbuhel') && seoName === '250') {
        return 'Kitzbuhel';
      } else if (tournamentName.includes('Stuttgart') && seoName === '250') {
        return 'Stuttgart';
      } else if (tournamentName.includes('Mallorca') && seoName === '250') {
        return 'Mallorca';
      } else if (tournamentName.includes('Geneva') && seoName === '250') {
        return 'Geneva';
      } else if (tournamentName.includes('Doha') && seoName === '500') {
        return 'Doha';
      } else if (tournamentName.includes('Adelaide') && seoName === '250') {
        return 'Adelaide';
      } else if (tournamentName.includes('Auckland') && seoName === '250') {
        return 'Auckland';
      } else if (tournamentName.includes('Brisbane') && seoName === '250') {
        return 'Brisbane';
      } else if (tournamentName.includes('Buenos Aires') && seoName === '250') {
        return 'BuenosAires';
      } else if (tournamentName.includes('Delray Beach') && seoName === '250') {
        return 'DelrayBeach';
      } else if (tournamentName.includes('Dallas') && seoName === '500') {
        return 'Dallas';
      } else if (tournamentName.includes('Acapulco') && seoName === '500') {
        return 'Acapulco';
      } else if (tournamentName.includes('Rio') && seoName === '500') {
        return 'Rio';
      } else if (tournamentName.includes('Santiago') && seoName === '250') {
        return 'Santiago';
      } else if (tournamentName.includes('Marrakech') && seoName === '250') {
        return 'Marrakech';
      } else if (tournamentName.includes('Marseille') && seoName === '250') {
        return 'Marseille';
      } else if (tournamentName.includes('Montpellier') && seoName === '250') {
        return 'Montpellier';
      } else if (tournamentName.includes('Bucharest') && seoName === '250') {
        return 'Bucharest';
      } else if (tournamentName.includes('Houston') && seoName === '250') {
        return 'Houston';
      } else if (tournamentName.includes('s-Hertogenbosch') && seoName === '250') {
        return "'s-Hertogenbosch";
      } else if (tournamentName.includes('Beijing') && seoName === '500') {
        return 'Beijing';
      } else if (tournamentName.includes('Tokyo') && seoName === '500') {
        return 'Tokyo';
      } else if (tournamentName.includes('Vienna') && seoName === '500') {
        return 'Vienna';
      } else if (tournamentName.includes('Basel') && seoName === '500') {
        return 'Basel';
      } else if (tournamentName.includes('Munich') && seoName === '500') {
        return 'Munich';
      } else if (tournamentName.includes('Antwerp') && seoName === '250') {
        return 'Antwerp';
      } else if (tournamentName.includes('Stockholm') && seoName === '250') {
        return 'Stockholm';
      } else if (tournamentName.includes('Metz') && seoName === '250') {
        return 'Metz';
      } else if (tournamentName.includes('Hangzhou') && seoName === '250') {
        return 'Hangzhou';
      } else if (tournamentName.includes('Chengdu') && seoName === '250') {
        return 'Chengdu';
      } else if (tournamentName.includes('Almaty') && seoName === '250') {
        return 'Almaty';
      } else if (tournamentName.includes('Winston-Salem') && seoName === '250') {
        return 'WinstonSalem';
      }
      
      return null;
    };
    
    // Process previous year tournaments
    if (dataPreviousYear.TournamentInstances) {
        dataPreviousYear.TournamentInstances.forEach(tournament => {
            const tournamentName = tournament.InstanceName;
            const startDate = new Date(tournament.StartDate);
            const seoName = tournament.HostCountry?.SeoName;            
        
        // Only include ATP tournaments (250, 500, 1000, WC, XXI)
        if (seoName && (seoName === '250' || seoName === '500' || seoName === '1000' || seoName === 'WC' || seoName === 'XXI')) {
            //const mappedName = mapTournamentName(tournamentName, seoName);
            const mappedName = tournament.city || mapTournamentName(tournamentName, seoName);
          if (mappedName) {
              tournamentDates[`${mappedName}_${previousYear}`] = {
              date: startDate,
              seoName: seoName,
              year: previousYear
            };
          }
        }
      });
    }
    
    // Process current year tournaments
        if (dataCurrentYear.TournamentInstances) {
            dataCurrentYear.TournamentInstances.forEach(tournament => {
            const tournamentName = tournament.InstanceName;
            const startDate = new Date(tournament.StartDate);
            const seoName = tournament.HostCountry?.SeoName;
        
        // Only include ATP tournaments (250, 500, 1000, WC, XXI)
        if (seoName && (seoName === '250' || seoName === '500' || seoName === '1000' || seoName === 'WC' || seoName === 'XXI')) {
            //const mappedName = mapTournamentName(tournamentName, seoName);
            const mappedName = tournament.city || mapTournamentName(tournamentName, seoName);
          if (mappedName) {
              tournamentDates[`${mappedName}_${currentYear}`] = {
              date: startDate,
              seoName: seoName,
              year: currentYear
            };
          }
        }
      });
    }
    
    // Tournament dates loaded from API
    tournamentDatesCache = tournamentDates;
    return tournamentDatesCache;
    } catch (error) {
      console.error('Error fetching tournament dates from API:', error);
      return {};
    } finally {
      tournamentDatesPromise = null;
    }
  })();

  return tournamentDatesPromise;
};

/**
 * Process tournament data to extract insights information for line chart
 */

export const processInsightsData = async (data, tournaments) => {
  if (!data || data.length === 0) {
    return [];
  }
  
  // Transform graphic names to ensure consistent naming
  const transformedData = transformGraphicNames(data);

  // Fetch tournament dates from API
  const tournamentDates = await fetchTournamentDates();
      // Tournament dates loaded from API

  // Group data by tournament and year
    const tournamentGroups = {};

    console.log(tournaments)
  
  transformedData.forEach(row => {
      const tournament = row.Tournament;
      const eventId = row.EventId;
      const TournamentName = tournaments?.find(t => String(t.id) === String(eventId))?.city || tournament;
           
      const year = row.Year || '2025'; // Default to 2025 if no year
    
    // Create a unique key that includes both tournament name and year
    // This allows us to show Monte Carlo 2024 and Monte Carlo 2025 as separate entries
      const tournamentKey = `${TournamentName}_${year}`;
      //console.log(tournamentKey)
    
    if (!tournamentGroups[tournamentKey]) {
      tournamentGroups[tournamentKey] = {
        tournament: TournamentName,
        year: year,
        tournamentKey: tournamentKey,
        insights: 0,
        earliestDate: null,
        eventId: row.EventId || null // Preserve EventId for type lookup
      };
    }
    
    // Update EventId if we don't have one yet but this row does
    if (!tournamentGroups[tournamentKey].eventId && row.EventId) {
      tournamentGroups[tournamentKey].eventId = row.EventId;
    }
    
    // Count insights (rows containing insight-related terms in any column)
    const hasInsights = Object.values(row).some(value => {
      const strValue = String(value).toLowerCase();
      return strValue.includes('insights') || 
             strValue.includes('in attack') ||
             strValue.includes('balanceofpower') ||
             strValue.includes('balance of power') ||
             strValue.includes('shot quality') ||
             strValue.includes('conversion') ||
             strValue.includes('steal') ||
             strValue.includes('tennisviz') ||
             strValue.includes('player cards') ||
             strValue.includes('matchstats') ||
             strValue.includes('l3') ||
             strValue.includes('performanceratingmatchstats') ||
             strValue.includes('tennisviz overall performance rating');
    });
    
    if (hasInsights) {
      tournamentGroups[tournamentKey].insights++;
    }
    
    // Use API date if available, otherwise use data date
    if (tournamentDates[tournamentKey]) {
      tournamentGroups[tournamentKey].earliestDate = tournamentDates[tournamentKey].date;
    } else if (row.Date) {
      let date;
      if (typeof row.Date === 'string') {
        date = new Date(row.Date);
        // Parsing string date
      } else if (row.Date instanceof Date) {
        date = row.Date;
                  // Using Date object
      } else {
        // Handle pandas datetime objects or other formats
        date = new Date(row.Date);
                  // Parsing other format
      }
      
      if (!isNaN(date.getTime())) {
        if (!tournamentGroups[tournamentKey].earliestDate || date < tournamentGroups[tournamentKey].earliestDate) {
          tournamentGroups[tournamentKey].earliestDate = date;
        }
      }
    }
  });

      // Tournament dates processed for sorting

  // Debug: Log all tournaments found
  console.log('🔍 Tournaments found in insights data:', Object.keys(tournamentGroups).map(key => {
    const group = tournamentGroups[key];
    return `${group.tournament} ${group.year} (${group.insights} insights)`;
  }));
  
    // Convert to array and sort by 2025 dates
    const currentYear = new Date().getFullYear();
    const previousYear = currentYear - 1;
  const chartData = Object.values(tournamentGroups)
    .sort((a, b) => {
        // First, prioritize currentYear tournaments over previous
        if (a.year === currentYear && b.year !== currentYear) {
            return -1; // currentYear tournaments come first
        } else if (a.year !== currentYear && b.year === currentYear) {
            return 1; // currentYear tournaments come first
      }
      
      // For currentYear tournaments, sort by date
        if (a.year === currentYear && b.year === currentYear) {
        if (a.earliestDate && b.earliestDate) {
                              // Comparing currentYear tournaments
          return a.earliestDate - b.earliestDate;
        } else if (a.earliestDate && !b.earliestDate) {
          return -1; // a comes first
        } else if (!a.earliestDate && b.earliestDate) {
          return 1; // b comes first
        } else {
          // Both 2025 tournaments have no dates, sort alphabetically
          return a.tournament.localeCompare(b.tournament);
        }
      }
      
      // For previousYear tournaments, sort by date
        if (a.year === previousYear && b.year === previousYear) {
        if (a.earliestDate && b.earliestDate) {
                              // Comparing 2024 tournaments
          return a.earliestDate - b.earliestDate;
        } else if (a.earliestDate && !b.earliestDate) {
          return -1; // a comes first
        } else if (!a.earliestDate && b.earliestDate) {
          return 1; // b comes first
        } else {
          // Both 2024 tournaments have no dates, sort alphabetically
          return a.tournament.localeCompare(b.tournament);
        }
      }
      
      // Fallback: sort by tournament name and year
      if (a.tournament === b.tournament) {
        return a.year.localeCompare(b.year);
      }
      return a.tournament.localeCompare(b.tournament);
    })
    .map(item => ({
      tournament: item.tournament,
      year: item.year,
      tournamentKey: item.tournamentKey,
      insights: item.insights
    }));

  // Tournament data sorted and processed
  return chartData;
};

/**
 * Get tournament date mapping for reference
 */
export const getTournamentDateMapping = (data) => {
  if (!data || data.length === 0) {
    return {};
  }

  const tournamentDates = {};
  
  data.forEach(row => {
    const tournament = row.Tournament;
    if (row.Date && tournament) {
      const date = new Date(row.Date);
      if (!isNaN(date.getTime())) {
        if (!tournamentDates[tournament] || date < tournamentDates[tournament]) {
          tournamentDates[tournament] = date;
        }
      }
    }
  });

  return tournamentDates;
}; 